import { HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import {
  BrowserModule,
  BrowserTransferStateModule
} from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  APPLICATION_CONFIGURATION_PATH,
  APPLICATION_CONFIGURATION_URL
} from '@com-delta-idp/angular-core/environment/tokens';
import {
  ApplicationConfig,
  commonReducer,
  errorMessageReducer,
  formReducer,
  NgcFooterModule,
  NgcModule,
  slimNavReducer
} from '@com-delta-idp/mnx-components';
import { LoginModalWrapperModule } from '@com-delta-idp/mnx-login';
import { OAuthFeatureConfig, SessionGuard } from '@com-delta-idp/mnx-oauth';
import { profileTrackJsConfigService } from '@com-delta-idp/mnx-profile-shared';
import { SmartModule as LandingPageModule } from '@com-delta-idp/mnx-skymiles-landing-page';
import { installTrackJS, TrackJsConfigService } from '@com-delta-idp/mnx-utils';
import { EffectsModule } from '@ngrx/effects';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

const oAuthFeatureConfig: OAuthFeatureConfig = {
  app: 'PROFILE',
  endpointKey: 'APP_PROFILE_AUTH_CONFIG'
};

export function getLoginTypeValue(appConfig: ApplicationConfig) {
  return appConfig.get('APP_MODAL_TYPE');
}

export function getAllowVAChanges(appConfig: ApplicationConfig) {
  return appConfig.get('APP_ALLOW_VA_CHANGES');
}
@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule.withServerTransition({ appId: 'my-profile' }),
    BrowserAnimationsModule,
    BrowserTransferStateModule,
    AppRoutingModule,
    HttpClientModule,
    LandingPageModule,
    StoreModule.forRoot({}),
    EffectsModule.forRoot([]),
    NgcFooterModule,
    NgcModule.forRoot({
      rootUrlName: 'My Profile Landing Page'
    }),
    StoreModule.forRoot(
      {
        commonReducer: commonReducer,
        formReducer: formReducer,
        errorMessageReducer: errorMessageReducer,
        slimNavReducer: slimNavReducer
      },
      {
        metaReducers: !environment.production ? [] : [],
        runtimeChecks: {
          strictActionImmutability: true,
          strictStateImmutability: true
        }
      }
    ),
    !environment.production ? StoreDevtoolsModule.instrument() : [],
    StoreRouterConnectingModule.forRoot(),
    LoginModalWrapperModule
  ],
  providers: [
    {
      provide: APPLICATION_CONFIGURATION_URL,
      useValue: '/content/dam/delta-applications/profile/profile.config.json'
    },
    {
      provide: APPLICATION_CONFIGURATION_PATH,
      useValue: '/content/dam/delta-applications/profile/profile.config.json'
    },
    {
      provide: 'OAUTH_FEATURE_CONFIG',
      useValue: oAuthFeatureConfig
    },
    {
      provide: 'REDIRECT',
      useValue: true
    },
    {
      provide: TrackJsConfigService,
      useFactory: profileTrackJsConfigService()
    },
    {
      provide: APP_INITIALIZER,
      useFactory: installTrackJS,
      deps: [TrackJsConfigService],
      multi: true
    },
    {
      provide: 'LOGIN_TYPE',
      useFactory: getLoginTypeValue,
      deps: [ApplicationConfig]
    },
    {
      provide: 'APP_ALLOW_VA_CHANGES',
      useFactory: getAllowVAChanges,
      deps: [ApplicationConfig]
    },

    SessionGuard
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
